export default function CTASection() {
  return (
    <section id="contact" className="py-20 md:py-28 bg-carland-light">
      <div className="px-6 md:px-12 lg:px-20">
        <div className="max-w-3xl mx-auto text-center">
          {/* Image */}
          <div className="rounded-3xl overflow-hidden mb-12 mx-auto max-w-2xl reveal spring-scale" style={{ opacity: 0 }}>
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20representing%20connection%20and%20opportunity%20warm%20beige%20and%20cream%20tones%20with%20subtle%20geometric%20overlapping%20shapes%20soft%20film%20grain%20texture%20elegant%20sophisticated%20atmosphere%20for%20career%20and%20employment%20theme&width=1000&height=500&seq=carland-cta-image-011&orientation=landscape"
              alt="ثبت‌نام در کارلند"
              className="w-full h-64 md:h-80 object-cover object-top"
              loading="lazy"
              decoding="async"
            />
          </div>

          {/* Copy */}
          <h2 className="text-3xl md:text-5xl font-black text-carland-dark leading-tight mb-6 reveal spring-up" style={{ opacity: 0, animationDelay: '0.15s' }}>
            برای{' '}
            <span className="italic font-light text-carland-accent">ثبت‌نام کاملاً مجهز</span>
            {' '}و حرفه‌ای
          </h2>
          <p className="text-carland-muted text-base md:text-lg leading-relaxed mb-8 max-w-xl mx-auto reveal spring-up" style={{ opacity: 0, animationDelay: '0.3s' }}>
            به ادمین{' '}
            <strong className="text-carland-dark">@CarLandSupport</strong>
            {' '}در تلگرام مراجعه کنید. پس از تکمیل ثبت‌نام، از قسمت ورود وارد پنل شخصی خود شوید.
          </p>

          {/* Telegram Button */}
          <a
            href="https://t.me/CarLandSupport"
            target="_blank"
            rel="noopener noreferrer"
            className="px-10 py-4 rounded-full bg-carland-dark text-white font-semibold text-base hover:bg-carland-darker transition-all duration-300 cursor-pointer whitespace-nowrap inline-flex items-center gap-3 shadow-lg hover:shadow-xl hover:-translate-y-0.5 reveal bounce"
            style={{ opacity: 0, animationDelay: '0.45s' }}
          >
            <i className="ri-telegram-line text-xl"></i>
            <span>ثبت‌نام در تلگرام</span>
          </a>

          <p className="text-carland-muted text-xs mt-6 reveal spring-up" style={{ opacity: 0, animationDelay: '0.6s' }}>
            با ثبت‌نام در کارلند، به جمع ۴۷,۰۰۰+ کارجوی موفق بپیوندید
          </p>
        </div>
      </div>
    </section>
  );
}